const book = {

    // headings
    createBook: 'Create Book',
    createBookBundle: 'Create Book Bundle',
    editBook: 'Edit Book',
    editBookBundle: 'Edit Book Bundle',
    bookSubmission: 'Book Submission',
    editBookSubmission: 'Edit Book Submission',

    // List
    bookList: 'Book List',
    receivedList: 'Received Book List',
    submittedList: 'Submitted Book List',
    bookBundleList: 'Book Bundle List',
    searchCriteria: 'Filter Preset',
    firstName: 'First Name',
    lastName: 'Last Name',
    studentNumber: 'Student Number',
    birthDate: 'Date of Birth',
    birthPlace: 'Place of Birth',
    presetName: 'Enter Preset Name',
    studentName: 'Student Name',
    action: 'Action',

    // Tabs
    tabGeneral: 'General',
    tabBasicInformation: 'Book Basic Information',
    tabAddCourse: 'Add in Course',
    tabAudit: 'Audit Log',
    tabStock: 'Stock Management',
    onStock: 'On Stock',
    bookOrders: 'Book Orders',
    currentStock: 'Current Stock:',
    
    // Labels
    photo: 'Photo',
    title: 'Title',
    author: 'Author',
    publisher: 'Publisher',
    edition: 'Edition',
    year: 'Year',
    ISBN: 'ISBN',
    courses: 'Courses',
    searchCourse: 'Search course',
    bookBundle: 'Book Bundle',
    searchStudent: 'Search by Student Name',
    print: 'Print',
    book: 'Book',
    dateReceived: 'Date Received',
    takingDate: 'Taking Date',
    description: 'Description',
    creationDate: 'Creation Date',
    books: 'Books',
    searchBooks: 'Search Books',
    addBookBundle: 'Add Book in Bundle',

    // stock tab
    receiveDate: 'Receive Date',
    orderDate: 'Order Date',
    amount: 'Amount',
    adjust_stock: 'The stock count should get adjusted accordingly.',
    
    //submissions 
    list_books_received:'List of All Books Received',
    book_received_on: 'BOOK RECEIVED ON',
    add_stock_back_confirm:'Do you want to add the books back to the stock count?'

};

export default book;
